import { useSelector } from 'react-redux';
import { cn } from '../../../utils';

export default function CustomTab({
  tab,
  isHighlighted = true,
  onClickHandler,
  className,
}) {
  const lang = useSelector(({ common }) => common?.language);
  return (
    <div
      className={cn(
        'flex cursor-pointer items-center justify-center py-4',
        className
      )}
    >
      <div
        onClick={() => onClickHandler(tab)}
        className={cn(
          isHighlighted &&
            'underline decoration-[#000] decoration-[2px] underline-offset-4 lg:underline-offset-8 ',
          `text-sm font-semibold uppercase text-black `
        )}
      >
        {tab?.name === 'for_you' ? lang?.common?.for_you : tab?.name || tab?.label}
      </div>
    </div>
  );
}
